"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnswerTable = void 0;
var _HintMark = _interopRequireDefault(require("01_core/components/materials/HintMark"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styles = require("@mui/material/styles");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BORDER = '1px solid #CCCCCC';
const StyledTable = (0, _styles.styled)(_Table.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  };
});
const StyledTableHead = (0, _styles.styled)(_TableHead.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    '& th': {
      background: theme.palette.table.header.primary.main,
      color: theme.palette.table.header.primary.contrastText,
      fontSize: theme.typography.fontSize,
      fontWeight: 'normal',
      paddingLeft: theme.spacing(1),
      paddingRight: 0
    }
  };
});
const StyledHintMark = (0, _styles.styled)(_HintMark.default)({
  color: 'white'
});
const StyledTableBody = (0, _styles.styled)(_TableBody.default)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    '& td': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      fontSize: theme.typography.fontSize
    }
  };
});
const RowTitle = (0, _styles.styled)(_TableRow.default)(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    background: theme.palette.table.body.secondary.main,
    borderBottom: BORDER
  };
});
const RowData = (0, _styles.styled)(_TableRow.default)(_ref5 => {
  let {
    theme
  } = _ref5;
  return {
    background: theme.palette.table.body.primary.main
  };
});
const CellBorderRb = (0, _styles.styled)(_TableCell.default)({
  whiteSpace: 'pre-line',
  borderRight: BORDER,
  borderBottom: BORDER
});
const CellBorderB = (0, _styles.styled)(_TableCell.default)({
  borderBottom: BORDER
});
const KakushoExpDiv = (0, _styles.styled)('div')(_ref6 => {
  let {
    theme
  } = _ref6;
  return {
    paddingTop: theme.spacing(2)
  };
});

/**
 * 監査回答登録一覧テーブルコンポーネント
 */
class AnswerTable extends _react.default.Component {
  render() {
    const {
      intl,
      columns,
      rowData,
      createRow
    } = this.props;
    const rows = rowData.map((data, index) => {
      return createRow(data, index);
    });
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledTable, null, /*#__PURE__*/_react.default.createElement(StyledTableHead, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, columns.map((column, index) => {
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        key: 'header_' + index,
        width: column.width
      }, column.label, column.hint && /*#__PURE__*/_react.default.createElement(StyledHintMark, {
        hint: column.hint
      }));
    }))), /*#__PURE__*/_react.default.createElement(StyledTableBody, null, rowData.map((data, index) => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, (() => {
        if (data.recordKbn === 'HEAD') {
          return /*#__PURE__*/_react.default.createElement(RowTitle, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
            colSpan: columns.length
          }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
            variant: "body2"
          }, rows[index].kakuninJiko)));
        } else {
          return /*#__PURE__*/_react.default.createElement(RowData, null, /*#__PURE__*/_react.default.createElement(CellBorderRb, null, rows[index].kakuninJiko, /*#__PURE__*/_react.default.createElement(KakushoExpDiv, null, intl.formatMessage({
            id: _labelConsts.LABEL.KANSA_SHITEKI_KAKUSHO_EXM
          })), /*#__PURE__*/_react.default.createElement("div", null, rows[index].kakushoExp)), /*#__PURE__*/_react.default.createElement(CellBorderRb, null, rows[index].kakuninKekkaCd), /*#__PURE__*/_react.default.createElement(CellBorderRb, null, rows[index].kakuninHosoku), /*#__PURE__*/_react.default.createElement(CellBorderRb, null, rows[index].hakkenjikoBunruiCd), /*#__PURE__*/_react.default.createElement(CellBorderRb, null, rows[index].hakkenjiko), rows[index].seijukudoHyoka ? /*#__PURE__*/_react.default.createElement(CellBorderB, null, rows[index].seijukudoHyoka) : /*#__PURE__*/_react.default.createElement(_TableCell.default, null, rows[index].seijukudoHyoka));
        }
      })());
    }))));
  }
}
exports.AnswerTable = AnswerTable;
var _default = exports.default = (0, _reactIntl.injectIntl)(AnswerTable);